export const allowedBetTrackingPlayerMarkets = [
  'PLAYER_TO_COMMIT_2_OR_MORE_FOULS',
  'PLAYER_TO_COMMIT_2_OR_MORE_FOULS_STAR_SUB',
  'PLAYER_TO_COMMIT_3_OR_MORE_FOULS',
  'PLAYER_TO_COMMIT_3_OR_MORE_FOULS_STAR_SUB',
  'PLAYER_TO_HAVE_1_OR_MORE_SHOTS_ON_TARGE',
  'PLAYER_TO_HAVE_1_OR_MORE_SHOTS_ON_TARGET',
  'PLAYER_TO_HAVE_1_OR_MORE_SHOTS_ON_TARGET_STAR_SUB',
  'PLAYER_TO_HAVE_2_OR_MORE_SHOTS_ON_TARGET',
  'PLAYER_TO_HAVE_2_OR_MORE_SHOTS_ON_TARGET_STAR_SUB',
  'PLAYER_TO_HAVE_3_OR_MORE_SHOTS_ON_TARGE',
  'PLAYER_TO_HAVE_3_OR_MORE_SHOTS_ON_TARGET',
  'PLAYER_TO_HAVE_3_OR_MORE_SHOTS_ON_TARGET_STAR_SUB',
  'PLAYER_TO_HAVE_4_OR_MORE_SHOTS_ON_TARGE',
  'PLAYER_TO_HAVE_4_OR_MORE_SHOTS_ON_TARGET',
  'PLAYER_TO_HAVE_4_OR_MORE_SHOTS_ON_TARGET_STAR_SUB',
  'PLAYER_TO_HAVE_1_OR_MORE_SHOTS_ON_TARGET_IN_1ST_HALF',
  'PLAYER_TO_HAVE_2_OR_MORE_SHOTS_ON_TARGET_IN_1ST_HALF',
  'PLAYER_TO_HAVE_1_OR_MORE_SHOTS',
  'PLAYER_TO_HAVE_2_OR_MORE_SHOTS',
  'PLAYER_TO_HAVE_3_OR_MORE_SHOTS',
  'PLAYER_TO_HAVE_4_OR_MORE_SHOTS',
  'PLAYER_TO_HAVE_5_OR_MORE_SHOTS',
  'PLAYER_TO_HAVE_6_OR_MORE_SHOTS',
  'PLAYER_TO_HAVE_1_OR_MORE_SHOTS_IN_1ST_H',
  'PLAYER_TO_HAVE_2_OR_MORE_SHOTS_IN_1ST_H',
  'PLAYER_TO_HAVE_3_OR_MORE_SHOTS_IN_1ST_H',
  'PLAYER_TO_HAVE_1_OR_MORE_SHOTS_IN_1ST_HALF',
  'PLAYER_TO_HAVE_2_OR_MORE_SHOTS_IN_1ST_HALF',
  'PLAYER_TO_HAVE_3_OR_MORE_SHOTS_IN_1ST_HALF',
  'TO_SCORE_2_OR_MORE_GOALS',
  'TO_SCORE_2_OR_MORE_GOALS_STAR_SUB',
  'TO_SCORE_A_HAT-TRICK',
  'TO_SCORE_A_HAT-TRICK_STAR_SUB',
  'PLAYER_TO_HAVE_A_SHOT_ON_TARGET_IN_EACH_HALF',
  'PLAYER_TO_HAVE_2_OR_MORE_SHOTS_ON_TARGET_IN_EACH_HALF',
  'PLAYER_TO_COMMIT_1_OR_MORE_FOULS_IN_EAC',
  'PLAYER_TO_COMMIT_1_OR_MORE_FOULS_IN_EACH_HALF',
  'PLAYER_TO_HAVE_A_SHOT_IN_EACH_HALF'
];

export const allowedLinearBetTrackingPlayerMarkets = [
  'PLAYER_TO_ATTEMPT_20_OR_MORE_PASSES',
  'PLAYER_TO_ATTEMPT_30_OR_MORE_PASSES',
  'PLAYER_TO_ATTEMPT_40_OR_MORE_PASSES',
  'PLAYER_TO_ATTEMPT_50_OR_MORE_PASSES',
  'PLAYER_TO_ATTEMPT_60_OR_MORE_PASSES',
  'PLAYER_TO_ATTEMPT_70_OR_MORE_PASSES',
  'PLAYER_TO_ATTEMPT_80_OR_MORE_PASSES',
  'PLAYER_TO_ATTEMPT_90_OR_MORE_PASSES',
  'PLAYER_TO_ATTEMPT_100_OR_MORE_PASSES'
];

export const restrictedBetTrackingPlayerMarkets = [
  'ANYTIME_ASSIST',
  'ANYTIME_ASSIST_STAR_SUB',
  'ANYTIME_GOALSCORER_STAR_SUB',
  'ANYTIME_GOALSCORER_ITALIA_STAR_SUB',
  'ITALIAN_ANYTIME_GOALSCORER',
  'PLAYER_TO_COMMIT_1_OR_MORE_FOULS',
  'PLAYER_TO_COMMIT_1_OR_MORE_FOULS_STAR_SUB',
  'PLAYER_TO_COMMIT_1_OR_MORE_FOULS_IN_FIR',
  'PLAYER_TO_COMMIT_1_OR_MORE_FOULS_IN_FIRST_HALF',
  '1ST_PLAYER_TO_BE_SHOWN_A_CARD',
  'TO_SCORE',
  'TO_SCORE_OR_ASSIST',
  'TO_SCORE_OR_ASSIST_STAR_SUB',
  'TO_SCORE_OR_TO_BE_SHOWN_A_CARD',
  'TO_SCORE_OR_BE_SHOWN_A_CARD_STAR_SUB'
];
